import { format } from 'date-fns';

// The refund screens always show fiat with 2 decimals (e.g. NGN 478,392.00),
// unlike the app-wide formatFiatCurrency which drops trailing zeros.
const fiatAmount = (value) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(value) || 0);

// Crypto amounts in the modal are shown to a maximum of 6 decimal places.
const cryptoAmount = (value) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6
  }).format(Number(value) || 0);

/** "NGN 478,392.00" — currency code before the fiat amount, per the design. */
export const fiat = (amount, currency) =>
  `${(currency || '').toUpperCase()} ${fiatAmount(amount)}`.trim();

const FIAT_CODES = new Set(['NGN', 'USD', 'GHS', 'KES', 'ZAR', 'GBP', 'EUR', 'XOF', 'XAF']);

/**
 * Currency-aware amount (code prefix): fiat to 2 dp, crypto (e.g. BTC) to 5 dp,
 * so small crypto excesses render as "BTC 0.00005" rather than "BTC 0.00".
 */
export const amountByCurrency = (amount, currency) => {
  const code = (currency || '').toUpperCase();
  const formatted = FIAT_CODES.has(code) ? fiatAmount(amount) : cryptoAmount(amount);
  return `${code} ${formatted}`.trim();
};

/** "0.00176 BTC" — crypto amount (max 6 dp) before the currency code. */
export const crypto = (amount, currency) =>
  `${cryptoAmount(amount)} ${(currency || '').toUpperCase()}`.trim();

/** "280,977.02 NGN" — fiat amount followed by the currency code. */
export const fiatSuffix = (amount, currency) =>
  `${fiatAmount(amount)} ${(currency || '').toUpperCase()}`.trim();

/** "1 BTC = 99,777,000.00 NGN" — one unit of payout currency in settlement currency. */
export const rateDisplay = (payoutCurrency, rate, settlementCurrency) =>
  `1 ${(payoutCurrency || '').toUpperCase()} = ${fiatAmount(rate)} ${(
    settlementCurrency || ''
  ).toUpperCase()}`.trim();

/** "03 - 10 - 2026 | 08:23:27" */
export const detailDate = (iso) => {
  if (!iso) return '--';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '--';
  return format(date, 'dd - MM - yyyy | HH:mm:ss');
};
